/**
 * * Configuração do componente de botão pequeno.
 */
export class MiniBtnConfig {

  constructor(
    /**
     * * Classe do ícone.
     */
    public icon: string,
    /**
     * * Cor do botão.
     */
    public color: 'yellow' | 'red' | 'blue' | 'green',
    /**
     * * Identificador do botão.
     */
    public id?: string,
    /**
     * * Aplicar margem à direita.
     */
    public marginRight?: boolean,
    /**
     * * Botão desabilitado.
     */
    public disabled?: boolean,
  ) {}

}
